import InputCus from "../../Component/InputCus/Text/InputCus";
import { useEffect, useState } from "react";
import {
  CompetitorCreateCategory,
  CompetitorFilterCategory,
  CompetitorUpdateCategory,
} from "../../Api/Services";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

function CompetitorCategoryAE() {
  const [isLoading, setLoading] = useState(true);
  const [form, setForm] = useState({});

  const navigate = useNavigate();

  let { id } = useParams();
  const start = async () => {
    try {
      if (id) {
        const CompetitorFilterCategoryData = await CompetitorFilterCategory({
          id: id,
        });
        if (
          CompetitorFilterCategoryData.status &&
          CompetitorFilterCategoryData.status === 200
        ) {
          setForm(CompetitorFilterCategoryData.data.data.data[0]);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const AddUpdate = async () => {
    let validation = true;
    if (form.name === "") {
      toast.error("نام را وارد نمایید ");
      validation = false;
    }
    if (form.color === "") {
      toast.error("رنگ را وارد نمایید ");
      validation = false;
    }
    if (validation) {
      setLoading(true);
      try {
        if (id) {
          const CompetitorUpdateCategoryData = await CompetitorUpdateCategory(
            form
          );
          if (
            CompetitorUpdateCategoryData.status &&
            CompetitorUpdateCategoryData.status === 200
          ) {
            toast.success("بروزرسانی با موفقیت انجام شد");
            navigate("/Panel/CompetitorsCategory");
          }
        } else {
          const CompetitorCreateCategoryData = await CompetitorCreateCategory(
            form
          );
          if (
            CompetitorCreateCategoryData.status &&
            CompetitorCreateCategoryData.status === 200
          ) {
            toast.success("افزودن  با موفقیت انجام شد");
            navigate("/Panel/CompetitorsCategory");
          }
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChangeSearch = (e) => {
    const newForm = { ...form };
    newForm[e.target.id] = e.target.value;
    setForm(newForm);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-between align-items-start p-5">
          <div className="d-flex justify-content-start align-items-center flex-column element w-100 p-5">
            <div className="d-flex justify-content-start align-items-center flex-column w-100">
              <InputCus
                className="m-2"
                type="text"
                name="name"
                id="name"
                text="نام"
                value={form.name || ""}
                onChange={handleChangeSearch}
              />
              <div className="d-flex justify-content-center m-2 w-100 flex-wrap">
                <div
                  onClick={() => {
                    setForm({ ...form, color: "Code1" });
                  }}
                  className={`Code1 p-3 rounded-circle m-2 border border-3 ${
                    form.color == "Code1" && "border-warning"
                  }`}
                ></div>
                <div
                  onClick={() => {
                    setForm({ ...form, color: "Code2" });
                  }}
                  className={`Code2 p-3 rounded-circle m-2 border border-3 ${
                    form.color == "Code2" && "border-warning"
                  }`}
                ></div>
                <div
                  onClick={() => {
                    setForm({ ...form, color: "Code3" });
                  }}
                  className={`Code3 p-3 rounded-circle m-2 border border-3 ${
                    form.color == "Code3" && "border-warning"
                  }`}
                ></div>
                <div
                  onClick={() => {
                    setForm({ ...form, color: "Code4" });
                  }}
                  className={`Code4 p-3 rounded-circle m-2 border border-3 ${
                    form.color == "Code4" && "border-warning"
                  }`}
                ></div>
                <div
                  onClick={() => {
                    setForm({ ...form, color: "Code5" });
                  }}
                  className={`Code5 p-3 rounded-circle m-2 border border-3 ${
                    form.color == "Code5" && "border-warning"
                  }`}
                ></div>
                <div
                  onClick={() => {
                    setForm({ ...form, color: "Code6" });
                  }}
                  className={`Code6 p-3 rounded-circle m-2 border border-3 ${
                    form.color == "Code6" && "border-warning"
                  }`}
                ></div>
                <div
                  onClick={() => {
                    setForm({ ...form, color: "Code7" });
                  }}
                  className={`Code7 p-3 rounded-circle m-2 border border-3 ${
                    form.color == "Code7" && "border-warning"
                  }`}
                ></div>
                <div
                  onClick={() => {
                    setForm({ ...form, color: "Code8" });
                  }}
                  className={`Code8 p-3 rounded-circle m-2 border border-3 ${
                    form.color == "Code8" && "border-warning"
                  }`}
                ></div>
                <div
                  onClick={() => {
                    setForm({ ...form, color: "Code9" });
                  }}
                  className={`Code9 p-3 rounded-circle m-2 border border-3 ${
                    form.color == "Code9" && "border-warning"
                  }`}
                ></div>
                <div
                  onClick={() => {
                    setForm({ ...form, color: "Code10" });
                  }}
                  className={`Code10 p-3 rounded-circle m-2 border border-3 ${
                    form.color == "Code10" && "border-warning"
                  }`}
                ></div>
                <div
                  onClick={() => {
                    setForm({ ...form, color: "Code11" });
                  }}
                  className={`Code11 p-3 rounded-circle m-2 border border-3 ${
                    form.color == "Code11" && "border-warning"
                  }`}
                ></div>
                <div
                  onClick={() => {
                    setForm({ ...form, color: "Code12" });
                  }}
                  className={`Code12 p-3 rounded-circle m-2 border border-3 ${
                    form.color == "Code12" && "border-warning"
                  }`}
                ></div>
                <div
                  onClick={() => {
                    setForm({ ...form, color: "Code13" });
                  }}
                  className={`Code13 p-3 rounded-circle m-2 border border-3 ${
                    form.color == "Code13" && "border-warning"
                  }`}
                ></div>
                <div
                  onClick={() => {
                    setForm({ ...form, color: "Code14" });
                  }}
                  className={`Code14 p-3 rounded-circle m-2 border border-3 ${
                    form.color == "Code14" && "border-warning"
                  }`}
                ></div>
                <div
                  onClick={() => {
                    setForm({ ...form, color: "Code15" });
                  }}
                  className={`Code15 p-3 rounded-circle m-2 border border-3 ${
                    form.color == "Code15" && "border-warning"
                  }`}
                ></div>
                <div
                  onClick={() => {
                    setForm({ ...form, color: "Code16" });
                  }}
                  className={`Code16 p-3 rounded-circle m-2 border border-3 ${
                    form.color == "Code16" && "border-warning"
                  }`}
                ></div>
                <div
                  onClick={() => {
                    setForm({ ...form, color: "Code17" });
                  }}
                  className={`Code17 p-3 rounded-circle m-2 border border-3 ${
                    form.color == "Code17" && "border-warning"
                  }`}
                ></div>
                <div
                  onClick={() => {
                    setForm({ ...form, color: "Code18" });
                  }}
                  className={`Code18 p-3 rounded-circle m-2 border border-3 ${
                    form.color == "Code18" && "border-warning"
                  }`}
                ></div>
                <div
                  onClick={() => {
                    setForm({ ...form, color: "Code19" });
                  }}
                  className={`Code19 p-3 rounded-circle m-2 border border-3 ${
                    form.color == "Code19" && "border-warning"
                  }`}
                ></div>
                <div
                  onClick={() => {
                    setForm({ ...form, color: "Code20" });
                  }}
                  className={`Code20 p-3 rounded-circle m-2 border border-3 ${
                    form.color == "Code20" && "border-warning"
                  }`}
                ></div>
                <div
                  onClick={() => {
                    setForm({ ...form, color: "Code21" });
                  }}
                  className={`Code21 p-3 rounded-circle m-2 border border-3" ${
                    form.color == "Code21" && "border-warning"
                  }`}
                ></div>
              </div>
            </div>
            <div className="d-flex justify-content-start align-items-center w-100 m-5">
              <button onClick={AddUpdate} className="butAU">
                {id ? "ویرایش" : "افزودن"}{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompetitorCategoryAE;
